<template>
  <section class="step4-form" :style="{minHeight:(screenHeight-85)+'px'}">
    <div class="step-form__step-num">4/5</div>
    <div class="step-form__main">
      <h1 class="step-form__title">资料附件确认</h1>
      <div class="step-form__file-list file-list" v-for="(item, index) in fileTypeList">
        <h6 class="file-list__item-title"><span>{{`${item.fileName}${item.customerFileIsMustUpload === '1' ? '（必传）' : ''}`}}</span></h6>
        <div class="file-list__item-content">
          <ul class="file-list__item-list">
            <template v-for="file in fileList[index].files">
              <li
                v-if="/\.pdf|\.doc|\.rar|\.zip|\.7z/g.test(file.fileName)" :class="['file-list__item-preview', `file-list__${file.fileName.substr(file.fileName.lastIndexOf('.')+1)}-preview`]"
                @click.self="showPreviewImage(file.fileId, false)">
                <div class="file-list__item-delete" @click="deleteUploadedFile(item.fileId, file)" v-if="!file.hasSaved">
                  <i class="el-icon-close"></i>
                </div>
                <div class="file-list__file-name">{{file.fileName}}</div>
              </li>
              <li v-else class="file-list__item-preview">
                <img :src="`${ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${file.fileId}&tokenId=${userInfo.token}`" @click="showPreviewImage(file.fileId, true)">
                <div v-if="!file.hasSaved" class="file-list__item-delete"
                     @click.stop="deleteUploadedFile(item.fileId, file)"><i class="el-icon-close"></i></div>
              </li>
            </template>
            <!--element-ui上传控件不支持IE9，使用webuploader插件替代-->
            <li class="file-list__select-file picker" @mousedown="changeFileType(item.fileId)">
              <i class="el-icon-plus"></i>
              <div class="file-list__select-file-title">{{item.fileName}}</div>
            </li>
          </ul>
        </div>
      </div>
      <!--加入百荣嵌入代码开始部分-->
    <table  class="tb1" border="1" style="display: none;">
      <tr><td class="title" >设备指纹</td><td id="gid"></td></tr>
      <tr><td class="title" >设备流水号</td><td id="console"></td></tr>
      <div id="sec1"></div>
      <div id="sec2"></div>
      <tr><td></td><td><button id="test" class="o BR_ATF_ACTION" style="display:none">button</button>
        <button class="loginBtn" onclick="loginHandler()">登录触发</button></td></tr>
    </table>
    <input type="hidden" id="br_gid">
    <!--加入百荣嵌入代码结束部分-->
      <div class="step-form__btn-container">
        <button class="step-form__btn-prev" @click="goBack">上一步</button>
        <button class="step-form__btn-next" @click="goNext">下一步</button>
      </div>
    </div>
    <el-dialog class="file-preview-modal" title="图片预览" :visible="filePreview.show" :before-close="hidePreviewImage"
               :close-on-click-modal="false">
      <div class="file-preview-modal__body">
        <img :src="filePreview.src" alt="图片预览">
      </div>
      <div slot="footer" class="dialog__footer">
        <button class="dialog__footer__confirm-btn" @click="hidePreviewImage">确定</button>
      </div>
    </el-dialog>

    <el-dialog class="progressDialog" title=" " :visible.sync="isShowProgress" size="tiny" top="40%" :show-close="false">
      <el-progress class="upload_progress" :text-inside="true" :stroke-width="18" :percentage="progress"></el-progress>
    </el-dialog>
  </section>
</template>
<script>
  import _ from 'lodash'
  import moment from 'moment'
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import * as types from '../../vuex/types'
  import 'webuploader/css/webuploader.css'
  import jq from 'jquery'
  import Webuploader from 'webuploader'

  export default {
    data () {
      return {
        progress: 0,
        isShowProgress: false,
        screenHeight: document.body.clientHeight,
        isAccord: false,
        uploader: null,
        fileTypeId: '',
        isSaving: false,
        filePreview: {
          show: false,
          src: ''
        }
      }
    },
    computed: {
      ...mapGetters({
        ajaxBaseUrl: types.GET_AJAX_BASE_URL,
        imgSrcPrefix: types.GET_IMAGE_SRC_PREFIX,
        userInfo: types.GET_USER,
        fileTypeList: types.GET_UPLOAD_FILE_TYPE_DATA,
        fileList: types.GET_UPLOAD_FILE_DATA
      })
    },
    methods: {
      ...mapActions({
        getFileList: types.SET_UPLOAD_FILE_DATA,
        saveFile: types.SAVE_UPLOADED_FILE,
        saveApplyLoanProgress: types.SAVE_APPLY_LOAN_PROGRESS,
        setSuccessMessage: types.SET_SUCCESS_MESSAGE,
        setFailMessage: types.SET_FAIL_MESSAGE
      }),
      ...mapMutations({
        saveCurrentUploadFiles: types.SAVE_CURRENT_UPLOAD_FILE,
        deleteFile: types.DELETE_UPLOADED_FILE
      }),
      calculateFileSize (bytes) {
        if (bytes > 1024 * 1024) {
          return `${(bytes / (1024 * 1024)).toFixed(2)}MB`
        } else if (bytes > 1024) {
          return `${(bytes / 1024).toFixed(2)}KB`
        } else {
          return `${bytes}B`
        }
      },
      deleteUploadedFile (typeId, file) {
        this.uploader.removeFile(file.uploaderId, true)
        this.deleteFile({
          typeId,
          file
        })
      },
      showPreviewImage (fileId, isImage) {
        const src = `${this.ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${fileId}&tokenId=${this.userInfo.token}`
        if (isImage) {
          this.filePreview = {
            show: true,
            src
          }
        } else {
          window.open(`${location.origin}${src}`)
        }
      },
      hidePreviewImage () {
        this.filePreview.show = false
      },
      renderBR:function(){
        var _this = this;
        function render(){
          var p = BRCore.prototype.options;
          document.querySelector('#br_gid').value = p.gid;

          var sec1HTML = '';
          var sec2HTML = '';
          var f = BRCore.inputs._f;
          for(var item in p){
            sec1HTML += '<tr><td class="title">' + item + '</td><td>' + p[item] + '</td></tr>';
          }

          for(var item1 in f.tag){
            sec2HTML += '<tr><td class="title">' + item1 + '</td><td>' + decodeURIComponent(f.tag[item1]) + '</td></tr>';
          }

          document.getElementById('sec1').innerHTML = '<table class="tb1" border="1">' + sec1HTML + '</table>';
          document.getElementById('sec2').innerHTML = '<table class="tb1" border="1">' + sec2HTML + '</table>';

          document.getElementById('gid').innerHTML = BRCore.prototype.options.gid;

        }

        isReady(function(){
          render();
        })

        function isReady(fn){
          var timer = setInterval(function(){
            try{
              if(BRCore.prototype.options.gid && BRCore.inputs._f.tag.bt){
                clearInterval(timer);
                timer = null;
                fn && fn();
              }
            }catch(e){

            }
          },100)
        }


        var win = window,
          doc = document,
          br = win["BAIRONG"] = win["BAIRONG"] || {},
          s = doc.createElement("script"),
          url = 'https://static.100credit.com/ifae/js/braf-v3.min.js';
        s.type = "text/javascript";
        s.charset = "utf-8";
        s.src = url;
        br.client_id = "3002052";//正式上线用apiCode

        //============= 可选 =============

        doc.getElementsByTagName("head")[0].appendChild(s);
        br.BAIRONG_INFO = {
          "app" : "antifraud",
          "event" : "login"//注册：register、借款：lend、登录：login、提现：cash
        }
        window.GetSwiftNumber=function(data){ //获取流水号的回调
          // console.log(data);//获取整个response
          // console.log(data.code); //获取返回code码
          // console.log(data.response.event);// 获取事件类型
          // console.log(data.response.af_swift_number); //获取设备请求流水号
          if(win.isGetSwiftNumberExec){
            //return;
          }
          win.isGetSwiftNumberExec = true;

          try{
            var af_swift_number = data.response.af_swift_number;
          }catch(e){
            var af_swift_number = 'null';
          }
          document.getElementById('console').innerHTML = af_swift_number;

        }

        window.loginHandler=function(){
          document.getElementById('test').click();
        }
      },
      goBack () {
        this.uploader.reset()
        this.saveApplyLoanProgress({
          router: this.$router,
          token: this.userInfo.token,
          id: this.$route.query.applyLoanId,
          bankAccountId: this.$route.query.selectedBankcardId,
          step: 3
        }).then((res) => {
          if (Number(res.data.code) === 0) {
            if (`${this.$route.query.isEdit}` === 'true') {
              this.$router.push({
                path: `/applyLoan/${this.$route.params.id}/step3_xd`,
                query: {
                  applyLoanId: this.$route.query.applyLoanId,
                  selectedBankcardId: this.selectedBankcardId,
                  isEdit: true
                }
              })
            } else {
              this.$router.go(-1)
            }
          }
        })
      },
      goNext () {
        // 必传的检查目前交给后台完成
        //alert( document.getElementById("br_gid").value)
       // return;
        this.saveFile({
          router: this.$router,
          token: this.userInfo.token,
          files: this.fileList
        }).then((saveRes) => {
          if (Number(saveRes.data.code) === 0) {
            this.saveApplyLoanProgress({
              router: this.$router,
              token: this.userInfo.token,
              id: this.$route.query.applyLoanId,
              step: 4,
              gid: document.getElementById("br_gid").value
            }).then((res) => {
              const resData = res.data
              if (Number(resData.code) === 0) {
                this.isSubmitting = false
                this.$router.push({
                  path: `/applyLoan/${this.$route.params.id}/step5_xd`,
                  query: {
                    applyLoanId: this.$route.query.applyLoanId
                  }
                })
              }
            })
          }
        })
      },
      changeFileType (fileTypeId) {
        this.fileTypeId = fileTypeId
      },
      uploadBeforeSend (obj, data) {
        data.fileTypeId = this.fileTypeId
        data.tokenId = this.userInfo.token
        this.isShowProgress = true
      },
      uploadProgress (file, percent) {
        const _this = this
//        const timer = setInterval(() => {
//          if (_this.progress >= percent * 100) {
//            clearInterval(timer)
//            _this.isShowProgress = false
//          }
//          _this.progress ++
//        }, 25)
        _this.progress = percent * 100
//        if (_this.progress >= percent * 100) _this.isShowProgress = false
      },
      uploadSuccess (file, res) {
        const arr = _.split(res, ':')
        this.saveCurrentUploadFiles({
          typeId: Number(arr[2].replace('fileTypeId=', '')),
          file: {
            fileId: Number(arr[0].replace('sysFile=', '')),
            date: moment(file.lastModified).format('YYYY-MM-DD hh:mm'),
            fileName: file.name,
            size: this.calculateFileSize(file.size),
            hasSaved: false,
            uploaderId: file.id,  // 上传文件id
            extension: file.name.substr(file.name.lastIndexOf('.') + 1),
            isImag: /image/g.test(file.type)
          }
        })
        this.progress = 0
        this.isShowProgress = false
      },
      uploadError (file, reason) {
        if (reason === 'http') {
          this.setFailMessage({
            show: true,
            content: '上传出错！请更新浏览器到最新版本或使用谷歌浏览器上传！'
          })
        }
        this.uploader.removeFile(file, true)
        this.progress = 0
        this.isShowProgress = false
      },
      uploadValidata (type) {
        switch (type) {
          case 'F_DUPLICATE': // 是否重复
            this.setFailMessage({
              show: true,
              content: '该文件您已经上传过了，请不要重复上传！'
            })
            break
          case 'Q_TYPE_DENIED': // 文件类型是否满足
            this.setFailMessage({
              show: true,
              content: '请上传后缀为.jpg，.gif，.bmp，.gif，.doc，.rar，.zip，.7z的文件'
            })
            break
          case 'Q_EXCEED_SIZE_LIMIT': // 文件大小是否超出
            this.setFailMessage({
              show: true,
              content: '请上传大小不超过50M的文件'
            })
            break
        }
      },
      createWebUploader () {
        this.uploader = Webuploader.create({
          auto: true, // 自动上传
          swf: './static/Uploader.swf',
          server: `${this.ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/saveFile.ht`,
          pick: {
            id: '.picker',
            multiple: true
          },
          chunked: true,
          duplicate: false, // 去重
          fileSizeLimit: 1024 * 1024 * 50,
          accept: {
            title: '*',
            extensions: 'gif,jpg,jpeg,bmp,png,doc,pdf,rar,zip',
            mimeTypes: 'image/*,application/msword,application/pdf,application/x-rar-compressed,application/x-zip-compressed,application/x-7z-compressed'
          }
        })
        this.uploader.on('uploadBeforeSend', this.uploadBeforeSend)
        this.uploader.on('uploadProgress', this.uploadProgress)
        this.uploader.on('uploadSuccess', this.uploadSuccess)
        this.uploader.on('uploadError', this.uploadError)
        this.uploader.on('error', this.uploadValidata)
      }
    },
    activated () {
      this.getFileList({
        router: this.$router,
        token: this.userInfo.token,
        id: this.$route.query.applyLoanId
      })
    },
    mounted () {
      this.$store.commit('changeActive', 4);
      jq()
      const _this = this
      setTimeout(() => {
        _this.createWebUploader()
        _this.uploader.refresh()
      }, 1000)
//      this.renderBR()//会导致上一步操作不成功，一直刷新当前页面
    }
  }
</script>
<style lang="scss">
  @import "../../styles/fileUpload";

  body{
    overflow: auto!important;
  }

  .step4-form .step-form__title {
    margin-bottom: 36px;
  }

  .file-preview-modal {
    .dialog__footer__confirm-btn {
      background-color: $orange;
    }
  }

  .file-preview-modal__body {
    overflow: auto;
  }
  .progressDialog{
    .el-dialog__header {
      display: none;
    }
    .dialog__close{display: none;}
  }
  .upload_progress{
    width:300px;
    margin:0 auto;
  }
</style>



// WEBPACK FOOTER //
// Step4_bak.vue?2aa0f4ef